import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M2.447 5.42C3.797 4.523 5.58 4 7.5 4c1.668 0 3.233.395 4.5 1.087C13.267 4.395 14.832 4 16.5 4c1.92 0 3.703.523 5.053 1.42a1 1 0 01.447.833v13a1 1 0 01-1.553.833C19.46 19.43 18.073 19 16.5 19c-1.563 0-2.944.426-3.929 1.074a.998.998 0 01-1.142 0C10.444 19.426 9.063 19 7.5 19c-1.572 0-2.961.431-3.947 1.086A1 1 0 012 19.253v-13a1 1 0 01.447-.833zM13 17.626A9.824 9.824 0 0116.5 17a9.82 9.82 0 013.5.626V6.819C19.06 6.317 17.849 6 16.5 6c-1.348 0-2.56.317-3.5.82v10.806zM11 6.82C10.06 6.317 8.848 6 7.5 6c-1.348 0-2.56.317-3.5.82v10.806A9.824 9.824 0 017.5 17c1.252 0 2.446.223 3.5.626V6.82z",
      stroke: "none"
    })]
  });
};
const IconBook = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "Book__IconBook",
  componentId: "sc-1n2gjra-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconBook };
